/**
 * Legacy desktop-context stub.
 *
 * The multi-tab desktop shell was retired in Iter I-25 in favour of the
 * 8-stage stepper. A few surviving tab components (BlockModelTab) still
 * import `useDesktop`. Rather than surgically strip each import, we
 * export a no-op hook here so those components keep compiling. Every
 * method is a silent no-op and every state field is a safe default.
 *
 * Once every consumer stops importing `useDesktop`, delete this file.
 */
const NOOP = () => {};
const STUB = {
  openTab: NOOP,
  closeTab: NOOP,
  activateTab: NOOP,
  updateTabTitle: NOOP,
  tabs: [],
  activeTabKey: null,
  isDesktop: false,
};

export function useDesktop() {
  return STUB;
}

export function DesktopProvider({ children }) {
  return children;
}

export default useDesktop;
